// Returns the number of apartments contracted for a building in an order
import { getToken } from './auth'
import { API_URL } from './config'
export async function getContractedApartments(orderId) {
  try {
    const token = getToken()
    const res = await fetch(`${API_URL}/orders/${orderId}/contracted-apartments`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })
    if (!res.ok) throw new Error('Could not obtain the contracted amount')
    const data = await res.json()
    return data.count || 0
  } catch (e) {
    throw new Error(e.message || 'Connection error')
  }
}

// Returns the number of apartments already attended in an order
export async function getAttendedApartments(orderId) {
  try {
    const token = getToken()
    const res = await fetch(`${API_URL}/orders/${orderId}/attended-apartments`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })
    if (!res.ok) throw new Error('Could not obtain the apartments attended')
    const data = await res.json()
    return data.count || 0
  } catch (e) {
    throw new Error(e.message || 'Connection error')
  }
}
